import { mergeStyles } from '@cian/components';
import * as React from 'react';

import * as styles from './index.css';

export interface IFeatureItemProps {
  name: string;
  className: string;
}

export class FeatureItem extends React.PureComponent<IFeatureItemProps, {}> {
  public render() {
    const { className, name } = this.props;

    return <li {...mergeStyles([styles['item'], styles[className]])}>{name}</li>;
  }
}
